module.exports = __webpack_public_path__ + "img/progress_067.579ef88f.png";